import { Routes } from '@angular/router';

import {
  StaticTimelineDemoComponent,
} from './static-timeline-demo.component';

export const staticTimelineRoutes: Routes = [
  { path: 'static-timeline', component: StaticTimelineDemoComponent },
];



// WEBPACK FOOTER //
// ./src/app/static-timeline/static-timeline.routes.ts